import React, { useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'qs';
import { Tabs } from 'antd';
import CustomerCareList from './CustomerCareList';
import CustomerComplaintList from '@/routes/customers/Detail/Complaints/CustomerComplaintList';
import { CustomerServiceOutlined, WarningOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;

const CustomerCareIndex = ({ customer }) => {

    const location = useLocation();
    const history = useHistory();
    const query = useMemo(() => qs.parse(location.search, { ignoreQueryPrefix: true }), [location.search]);

    const onTabClick = (key) => {
        // Cập nhật state và URL khi tab thay đổi
        history.push({
            pathname: location.pathname,
            search: qs.stringify({ ...query, child_tabs: key }),
        });
    };

    return (
        <div>
            <Tabs
                defaultActiveKey={query.child_tabs}
                size='middle'
                destroyInactiveTabPane
                tabBarStyle={{
                    fontWeight: 500,
                    background: "white",
                }}
                onChange={(value) => onTabClick(value)}
            >
                <TabPane tab={<span style={{ color: 'green' }}><CustomerServiceOutlined />Chăm sóc khách hàng</span>} key="customer_care">
                    <CustomerCareList customer={customer} />
                </TabPane>
                <TabPane tab={<span style={{ color: 'red' }}> <WarningOutlined />Phản ánh của khách hàng</span>} key="complaint">
                    <CustomerComplaintList customer={customer} />
                </TabPane>
            </Tabs>
        </div>
    );
};

export default CustomerCareIndex;
